import { Component, signal, ViewChild } from '@angular/core';

import { MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatError, MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { TranslateModule } from '@ngx-translate/core';
import { RsSpinnerButtonDirective } from '@rs-shared-lib/directives/spinner-button/rs-spinner-button.directive';
import { MatOption, MatSelect } from '@angular/material/select';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { BatchService } from '@batch/shared/services/batch.service';
import { RsAddClearFormFieldButtonDirective } from '@rs-shared-lib/directives/rs-add-clear-form-field-button/rs-add-clear-form-field-button.directive';
import { finalize } from 'rxjs/operators';
import { BatchFileType } from '@batch/shared/models/batch';
import { RsFileUploaderComponent, UploaderDoneEvent } from '@rs-shared-lib/components/file-uploader/rs-file-uploader.component';
import { RsMessagesHandlerService } from '@rs-shared-lib/components/rs-messages-handler/services/rs-messages-handler.service';
import { RsFile } from '@rs-shared-lib/models';

@Component({
  selector: 'ord-batch-bulk',
  imports: [
    MatDialogClose,
    MatDialogTitle,
    MatIcon,
    MatIconButton,
    MatSuffix,
    TranslateModule,
    RsFileUploaderComponent,
    MatButton,
    MatDialogActions,
    RsSpinnerButtonDirective,
    MatDialogContent,
    MatFormField,
    MatLabel,
    MatSelect,
    MatOption,
    MatError,
    ReactiveFormsModule,
    RsAddClearFormFieldButtonDirective
  ],
  templateUrl: './upload-file-dialog.component.html'
})
export class UploadFileDialogComponent {
  @ViewChild('fileUploader') public fileUploader!: RsFileUploaderComponent;
  protected readonly fileTypeControl: FormControl<string>;
  protected readonly fileTypeOptions: BatchFileType[] = ['UPDATE_EXPECTED_DELIVERY_DATES'];
  protected isBatchReadyToUpload: boolean = false;
  protected isBatchUploading = signal(false);

  constructor(
    private readonly batchService: BatchService,
    private readonly dialogRef: MatDialogRef<UploadFileDialogComponent>,
    private readonly rsMessagesHandlerService: RsMessagesHandlerService
  ) {
    this.fileTypeControl = new FormControl('', {
      nonNullable: true,
      validators: [Validators.required]
    });
  }

  public clearBatchFileType(event: UploaderDoneEvent): void {
    if (!event.withErrors) {
      this.fileTypeControl.reset();
    }
  }

  public uploadBatchFile(rsButtonSpinner: RsSpinnerButtonDirective): void {
    rsButtonSpinner.rsSpinnerButtonShow.set(true);

    const file = this.fileUploader.getUploaderFileAsArray(true)[0] as RsFile;
    const formData: FormData = new FormData();

    formData.append('fileType', this.fileTypeControl.value);
    formData.append('document', file.data, file.data.name);

    this.batchService.processBatch(formData)
      .pipe(finalize(() => rsButtonSpinner.rsSpinnerButtonShow.set(false)))
      .subscribe(() => {
        this.fileTypeControl.reset();
        this.fileUploader.resetFileUploader();
        this.rsMessagesHandlerService.showSuccessMsg();
        this.dialogRef.close(true);
      });
  }
}
